import { render } from "./PurchaseImportModal.vue?vue&type=template&id=8edafa92&scoped=true"
import script from "./PurchaseImportModal.vue?vue&type=script&lang=js"
export * from "./PurchaseImportModal.vue?vue&type=script&lang=js"

import "./PurchaseImportModal.vue?vue&type=style&index=0&id=8edafa92&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8edafa92"]])

export default __exports__